const initSEOCopyTogglers = () => {
  const seo_copy_togglers = document.querySelectorAll('.read-text-wrapper')
  seo_copy_togglers.forEach((toggler) => {
    toggler.addEventListener('click', (e) => {
      const seo_copy_parent = e.target.closest('.seo-copy-wrapper')
      if (seo_copy_parent.classList.contains('active')) {
        seo_copy_parent.classList.remove('active')
      } else {
        seo_copy_parent.classList.add('active')
      }
    })
  })
}
initSEOCopyTogglers()
